module.exports = __webpack_public_path__ + "img/Screen_4.95acc9fc.png";